// extracted by mini-css-extract-plugin
export var numpadContainer = "_rx-1";
export var phoneButton = "_rx-0";